import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { MessageModel } from '../models/message-model';

/**
 * Service de message
 */
@Injectable({
  providedIn: 'root'
})
export class MessageService {

    /**
     * Constructeur
     */
    constructor() { }

    private subject = new Subject<any>();

    /**
     * Envoyer un message
     * @param message
     * @param type
     */
    envoyerMessage(message: string, type: string = 'primary') {
        let msg = new MessageModel(message, type);
        this.envoyerMessageInterne(msg);
    }

    /**
     * Envoyer des messages
     * @param messages
     */
    envoyerMessages(messages: MessageModel[]) {
        for (let i = 0; i < messages.length; i++) {
            this.envoyerMessageInterne(messages[i]);
        }
    }

    /**
     * Envoyer un message
     * @param message
     */
    private envoyerMessageInterne(message: MessageModel) {
        this.subject.next(message);
    }

    /**
     * Obtenir le message
     */
    obtenirMessage(): Observable<MessageModel> {
        return this.subject.asObservable();
    }
}
